<!--suppress HtmlRequiredAltAttribute, HtmlUnknownTarget -->
<template>
  <div class="block">
    <agile class="main" ref="main" :options="options1" :as-nav-for="asNavFor1">
      <div class="slide" v-for="(slide, index) in images" :key="index" :class="`slide--${index}`"><img :src="slide" loading="lazy"/>
      </div>
    </agile>
    <agile class="thumbnails" ref="thumbnails" :options="options2" :as-nav-for="asNavFor2">
      <div class="slide slide--thumbnail" v-for="(slide, index) in images" :key="index" :class="`slide--${index}`"
           @click="$refs.thumbnails.goTo(index)">
        <img :src="slide" loading="lazy"/>
      </div>
    </agile>
  </div>
</template>

<script>
import {VueAgile} from 'vue-agile'

export default {
  name: "Slider",
  props: {
    images: {
      type: Array,
      required: true,
    },
    initialSlide: {
      type: Number,
      required: false,
      default: () => 0,
    },
  },
  components: {
    agile: VueAgile,
  },
  data() {
    return {
      asNavFor1: [],
      asNavFor2: [],
      options1: {
        dots: false,
        fade: true,
        navButtons: false,
        initialSlide: this.initialSlide,
      },

      options2: {
        autoplay: true,
        centerMode: true,
        dots: false,
        navButtons: false,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 5
            }
          },

          {
            breakpoint: 1000,
            settings: {
              navButtons: false
            }
          }
        ],
        initialSlide: this.initialSlide,
      },
    }
  },
  mounted() {
    this.asNavFor1.push(this.$refs.thumbnails)
    this.asNavFor2.push(this.$refs.main)
  }
}
</script>

<style lang="sass">
.main
  margin-bottom: 30px

// Basic VueAgile styles
.agile
  &__nav-button
    background: transparent
    border: none
    color: #ccc
    cursor: pointer
    font-size: 24px
    transition-duration: .3s

    .thumbnails &
      position: absolute
      top: 50%
      transform: translateY(-50%)

      &--prev
        left: -45px

      &--next
        right: -45px

    &:hover
      color: #888

  &__dot
    margin: 0 10px

    button
      background-color: #eee
      border: none
      border-radius: 50%
      cursor: pointer
      display: block
      height: 10px
      font-size: 0
      line-height: 0
      margin: 0
      padding: 0
      transition-duration: .3s
      width: 10px

    &--current,
    &:hover
      button
        background-color: #888

// Slides styles
.slide
  align-items: center
  box-sizing: border-box
  color: #fff
  display: flex
  height: auto
  justify-content: center
  border-radius: 5px
  overflow: hidden

  &--thumbnail
    cursor: pointer
    height: auto
    padding: 0 5px
    transition: opacity .3s
    border-radius: 10px
    overflow: hidden

    &:hover
      opacity: .75

  img
    height: 100%
    object-fit: cover
    object-position: center
    width: 100%
</style>